const HisPeople = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  return (
    <svg
      style={sx}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9302 28.1841V25.5225C21.9302 24.1106 21.3693 22.7567 20.371 21.7584C19.3727 20.7601 18.0187 20.1992 16.6069 20.1992H8.62207C7.21026 20.1992 5.85627 20.7601 4.85797 21.7584C3.85967 22.7567 3.29883 24.1106 3.29883 25.5225V28.1841"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6143 14.877C15.5542 14.877 17.9375 12.4937 17.9375 9.55371C17.9375 6.61377 15.5542 4.23047 12.6143 4.23047C9.67431 4.23047 7.29102 6.61377 7.29102 9.55371C7.29102 12.4937 9.67431 14.877 12.6143 14.877Z"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9143 28.183V25.5213C29.9134 24.3419 29.5209 23.1961 28.7982 22.2639C28.0756 21.3317 27.0639 20.666 25.9219 20.3711"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9297 4.40234C23.0747 4.69552 24.0896 5.36146 24.8144 6.29517C25.5392 7.22888 25.9326 8.37725 25.9326 9.55923C25.9326 10.7412 25.5392 11.8896 24.8144 12.8233C24.0896 13.757 23.0747 14.4229 21.9297 14.7161"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisPeople;
